import { render, staticRenderFns } from "./login.vue?vue&type=template&id=a23c303a"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=a23c303a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a23c303a')) {
      api.createRecord('a23c303a', component.options)
    } else {
      api.reload('a23c303a', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=a23c303a", function () {
      api.rerender('a23c303a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/auth/login/login.vue"
export default component.exports